import { gql } from "@apollo/client";

import { alertSummaryFragment } from "src/graphql/anti-fraud/fragments/AlertSummaryFragment.ts";
import { elementFragment } from "src/graphql/anti-fraud/fragments/ElementFragment";
import { propertyValueFragment } from "src/graphql/anti-fraud/fragments/PropertyValueFragment";

export const customerFragment = gql`
  fragment CustomerFragment on Customer {
    id
    elements {
      ...ElementFragment
    }
    properties {
      ...PropertyValueFragment
    }
    openAlerts {
      ...AlertSummaryFragment
    }
    typeCode
  }
  ${alertSummaryFragment}
  ${elementFragment}
  ${propertyValueFragment}
`;
